<template>
  <my-modal ref="popup">
    <div class="vk-redirect-content">
      <h4 class="formTitle">Перейти в ВК приложение Про100 Квиз для разрешения сообщений?</h4>
      <div class="buttonsRow">
        <my-button cls="pink" @click="_confirm">ДА</my-button>
        <my-button cls="blue" @click="_cancel">НЕТ</my-button>
      </div>
    </div>
  </my-modal>
</template>

<script>
import MyButton from "./MyButton";
import MyModal from "./MyModal";

export default {
  name: "VkAppRedirectModal",
  components: { MyButton, MyModal },
  props: {
    city_title: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    resolvePromise: undefined,
  }),
  methods: {
    open() {
      this.$refs.popup.open()
      return new Promise((resolve) => {
        this.resolvePromise = resolve
      })
    },
    _getGroupId() {
      // Заглушка - возвращаем фиксированный ID независимо от города
      // В будущем здесь будет запрос к API с использованием this.city_title
      return '225436190'
    },
    _confirm() {
      const groupId = this._getGroupId()
      const url = `https://vk.com/app54506386#group_id=${groupId}`
      window.open(url, '_blank')
      this.$refs.popup.close()
      if (this.resolvePromise) {
        this.resolvePromise(true)
      }
    },
    _cancel() {
      this.$refs.popup.close()
      if (this.resolvePromise) {
        this.resolvePromise(false)
      }
    },
  }
}
</script>

<style scoped>
.vk-redirect-content {
  max-width: 24rem;
  padding: 0;
}

.formTitle {
  font-size: 20px;
  line-height: 26px;
  font-weight: 700;
  letter-spacing: 0.165em;
  text-transform: uppercase;
  opacity: 0.6;
  text-align: left;
  margin-bottom: 20px;
}

.buttonsRow {
  display: flex;
  gap: 12px;
}

.buttonsRow :deep(.button) {
  width: 100%;
}
</style>

<!--
Пример использования компонента:

<template>
  <div>
    <button @click="showVkModal">Открыть ВК приложение</button>
    <vk-app-redirect-modal ref="vkModal" city_title="Москва" />
  </div>
</template>

<script>
import { VkAppRedirectModal } from '@/components/UI'

export default {
  components: { VkAppRedirectModal },
  methods: {
    async showVkModal() {
      const result = await this.$refs.vkModal.open()
      console.log('Результат:', result) // true - ДА, false - НЕТ
    }
  }
}
</script>
-->
